(() => {
  var __async = (__this, __arguments, generator) => {
    return new Promise((resolve, reject) => {
      var fulfilled = (value) => {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      };
      var rejected = (value) => {
        try {
          step(generator.throw(value));
        } catch (e) {
          reject(e);
        }
      };
      var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
      step((generator = generator.apply(__this, __arguments)).next());
    });
  };

  // node_modules/loadx/dist/loadx.module.js
  var n = function() {
    var n2 = {};
    function r(r2, t, e) {
      return new Promise(function(o, u) {
        if (t === null || !(t instanceof HTMLElement))
          return u(new Error("Parent not found."));
        var c = function(r3) {
          var t2 = JSON.stringify(r3), e2 = n2[t2];
          return e2 !== void 0 ? e2 : null;
        }(e);
        if (c !== null)
          return o(c);
        var i = document.createElement(r2);
        i.onload = function() {
          o(i), function(r3, t2) {
            var e2 = JSON.stringify(r3);
            n2[e2] = t2;
          }(e, i);
        }, i.onerror = function(n3) {
          u(new URIError("The asset " + n3.target.src + " didn't load correctly."));
        }, Object.keys(e).forEach(function(n3) {
          i[n3] = e[n3];
        }), t.appendChild(i);
      });
    }
    return r.js = function(n3) {
      return r("script", document.body, { src: n3 });
    }, r.css = function(n3) {
      return r("link", document.head, { type: "text/css", rel: "stylesheet", href: n3 });
    }, r.img = function(n3, t) {
      return r("img", function(n4) {
        return n4 === void 0 ? document.body : n4;
      }(t), { src: n3 });
    }, r;
  }();
  var loadx_module_default = n;

  // src/js/components/homeHeroSlider.js
  var HomeHeroSlider = class {
    constructor(params) {
      this.element = params.element;
      this.swipper = params.swiper;
    }
    static beforeCreate() {
      return __async(this, null, function* () {
        const sliders = window.Store.app.theBody.querySelectorAll(".js-homeHeroSlider");
        if (!sliders.length)
          return null;
        if (!window.Store.components.homeHeroSlider.cdn_is_loaded) {
          yield loadx_module_default.css("https://unpkg.com/swiper@7/swiper-bundle.min.css");
          yield loadx_module_default.js("https://unpkg.com/swiper@7/swiper-bundle.min.js");
          window.Store.components.homeHeroSlider.cdn_is_loaded = true;
        }
      });
    }
    static create() {
      const homeHeroSliderElement = window.Store.app.theBody.querySelectorAll(".js-homeHeroSlider");
      const slider = new Swiper(".js-homeHeroSlider", {
        slidesPerView: 1,
        pauseOnMouseEnter: true,
        pagination: {
          el: ".swiper-pagination",
          type: "progressbar"
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        keyboard: {
          enabled: true
        },
        a11y: {
          enabled: false
        },
        on: {
          init(swiper) {
            var _a;
            HomeHeroSlider.startAutoplay(swiper);
            console.log(swiper.slides[0].tagName);
            if (swiper.slides[0].tagName == "A") {
              swiper.slides[0].setAttribute("tabindex", "0");
            }
            (_a = swiper.slides[0].querySelector("a")) == null ? void 0 : _a.setAttribute("tabindex", "0");
            swiper.slides.forEach((slide, index) => {
              if (index == 0) {
                return;
              }
              if (slide.tagName == "A") {
                slide.setAttribute("tabindex", "-1");
              }
              slide.querySelectorAll("a, button").forEach((el) => {
                el.setAttribute("tabindex", "-1");
              });
            });
          },
          slideChange(swiper) {
            let prevSlideContent = swiper.el.querySelector('.js-homeHeroSlider__slideContent[data-index="' + swiper.previousIndex + '"');
            if (prevSlideContent) {
              prevSlideContent.classList.add("hide");
              prevSlideContent.querySelector("a").setAttribute("tabindex", "-1");
            }
            let currentSlideContent = swiper.el.querySelector('.js-homeHeroSlider__slideContent[data-index="' + swiper.activeIndex + '"');
            if (currentSlideContent) {
              currentSlideContent.classList.remove("hide");
              currentSlideContent.querySelector("a").setAttribute("tabindex", "0");
            }
          },
          activeIndexChange(swiper) {
            var _a;
            (_a = swiper.el.querySelector(".swiper-slide[tabindex='0']")) == null ? void 0 : _a.setAttribute("tabindex", "-1");
            if (swiper.slides[swiper.activeIndex].tagName == "A") {
              swiper.slides[swiper.activeIndex].setAttribute("tabindex", "0");
              document.activeElement.blur();
            }
          },
          touchStart(swiper) {
            swiper.params.speed = 350;
          }
        }
      });
      const params = {
        element: homeHeroSliderElement,
        swiper: slider
      };
      const obj = new HomeHeroSlider(params);
      obj.init();
      return obj;
    }
    static startAutoplay(swiper) {
      if (swiper.el.getAttribute("data-swiper-autoplay")) {
        swiper.params.speed = 1050;
        swiper.autoplay.start();
      }
    }
    init() {
    }
  };
  function render() {
    HomeHeroSlider.beforeCreate().then(() => {
      window.Store.components.homeHeroSlider.obj = HomeHeroSlider.create();
    });
  }
  window.Store.components.homeHeroSlider = {
    obj: null,
    render: null,
    cdn_is_loaded: false
  };
  window.Store.components.homeHeroSlider.render = render;
})();
